var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path, _path2, _g11, _g12, _path3, _path4, _path5, _path6, _path7, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1478 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1172.13 201.651C1172.72 201.651 1173.2 201.042 1173.2 200.291C1173.2 199.54 1172.72 198.931 1172.13 198.931C1171.54 198.931 1171.07 199.54 1171.07 200.291C1171.07 201.042 1171.54 201.651 1172.13 201.651Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1229.73 133.665C1230.32 133.665 1230.8 133.056 1230.8 132.306C1230.8 131.555 1230.32 130.946 1229.73 130.946C1229.14 130.946 1228.67 131.555 1228.67 132.306C1228.67 133.056 1229.14 133.665 1229.73 133.665Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.334 137.745C263.923 137.745 264.401 137.136 264.401 136.385C264.401 135.634 263.923 135.025 263.334 135.025C262.745 135.025 262.268 135.634 262.268 136.385C262.268 137.136 262.745 137.745 263.334 137.745Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1325.73 42.5661C1326.32 42.5661 1326.8 41.9573 1326.8 41.2064C1326.8 40.4554 1326.32 39.8467 1325.73 39.8467C1325.14 39.8467 1324.67 40.4554 1324.67 41.2064C1324.67 41.9573 1325.14 42.5661 1325.73 42.5661Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M683.6 317.225C684.189 317.225 684.667 316.617 684.667 315.866C684.667 315.115 684.189 314.506 683.6 314.506C683.011 314.506 682.533 315.115 682.533 315.866C682.533 316.617 683.011 317.225 683.6 317.225Z",
    fill: "#D9D9D9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.401 64.3205C120.99 64.3205 121.467 63.7117 121.467 62.9608C121.467 62.2098 120.99 61.6011 120.401 61.6011C119.812 61.6011 119.334 62.2098 119.334 62.9608C119.334 63.7117 119.812 64.3205 120.401 64.3205Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2659 113.27C22.855 113.27 23.3326 112.661 23.3326 111.91C23.3326 111.159 22.855 110.55 22.2659 110.55C21.6768 110.55 21.1992 111.159 21.1992 111.91C21.1992 112.661 21.6768 113.27 22.2659 113.27Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.26589 3.13395C6.85499 3.13395 7.33255 2.52519 7.33255 1.77425C7.33255 1.02331 6.85499 0.414551 6.26589 0.414551C5.67678 0.414551 5.19922 1.02331 5.19922 1.77425C5.19922 2.52519 5.67678 3.13395 6.26589 3.13395Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.934 106.471C209.523 106.471 210.001 105.863 210.001 105.112C210.001 104.361 209.523 103.752 208.934 103.752C208.345 103.752 207.867 104.361 207.867 105.112C207.867 105.863 208.345 106.471 208.934 106.471Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.401 247.88C456.99 247.88 457.467 247.271 457.467 246.52C457.467 245.769 456.99 245.161 456.401 245.161C455.812 245.161 455.334 245.769 455.334 246.52C455.334 247.271 455.812 247.88 456.401 247.88Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter10_d_2525_567)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M412.666 158.14C413.255 158.14 413.733 157.532 413.733 156.781C413.733 156.03 413.255 155.421 412.666 155.421C412.077 155.421 411.6 156.03 411.6 156.781C411.6 157.532 412.077 158.14 412.666 158.14Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter11_d_2525_567)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M361.467 232.924C362.056 232.924 362.534 232.315 362.534 231.564C362.534 230.813 362.056 230.204 361.467 230.204C360.878 230.204 360.4 230.813 360.4 231.564C360.4 232.315 360.878 232.924 361.467 232.924Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579.067 265.557C579.656 265.557 580.133 264.948 580.133 264.197C580.133 263.446 579.656 262.837 579.067 262.837C578.478 262.837 578 263.446 578 264.197C578 264.948 578.478 265.557 579.067 265.557Z",
    fill: "#D9D9D9"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1053.73 109.191C1054.32 109.191 1054.8 108.582 1054.8 107.831C1054.8 107.08 1054.32 106.472 1053.73 106.472C1053.14 106.472 1052.67 107.08 1052.67 107.831C1052.67 108.582 1053.14 109.191 1053.73 109.191Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter14_d_2525_567)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M527.867 200.291C528.457 200.291 528.934 199.682 528.934 198.931C528.934 198.181 528.457 197.572 527.867 197.572C527.278 197.572 526.801 198.181 526.801 198.931C526.801 199.682 527.278 200.291 527.867 200.291Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter15_d_2525_567)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M499.067 26.2492C499.656 26.2492 500.133 25.6404 500.133 24.8895C500.133 24.1385 499.656 23.5298 499.067 23.5298C498.478 23.5298 498 24.1385 498 24.8895C498 25.6404 498.478 26.2492 499.067 26.2492Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter16_d_2525_567)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M638.799 102.392C639.388 102.392 639.866 101.783 639.866 101.033C639.866 100.282 639.388 99.6729 638.799 99.6729C638.21 99.6729 637.732 100.282 637.732 101.033C637.732 101.783 638.21 102.392 638.799 102.392Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter17_d_2525_567)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M775.334 67.0397C775.923 67.0397 776.401 66.431 776.401 65.68C776.401 64.9291 775.923 64.3203 775.334 64.3203C774.745 64.3203 774.268 64.9291 774.268 65.68C774.268 66.431 774.745 67.0397 775.334 67.0397Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter18_d_2525_567)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M960.934 43.925C961.523 43.925 962.001 43.3162 962.001 42.5653C962.001 41.8143 961.523 41.2056 960.934 41.2056C960.345 41.2056 959.867 41.8143 959.867 42.5653C959.867 43.3162 960.345 43.925 960.934 43.925Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M632.401 223.406C632.99 223.406 633.467 222.797 633.467 222.046C633.467 221.295 632.99 220.687 632.401 220.687C631.812 220.687 631.334 221.295 631.334 222.046C631.334 222.797 631.812 223.406 632.401 223.406Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M768.934 223.406C769.523 223.406 770.001 222.797 770.001 222.046C770.001 221.295 769.523 220.687 768.934 220.687C768.345 220.687 767.867 221.295 767.867 222.046C767.867 222.797 768.345 223.406 768.934 223.406Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M835.067 306.347C835.656 306.347 836.133 305.739 836.133 304.988C836.133 304.237 835.656 303.628 835.067 303.628C834.478 303.628 834 304.237 834 304.988C834 305.739 834.478 306.347 835.067 306.347Z",
    fill: "#D9D9D9"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1099.6 188.053C1100.19 188.053 1100.67 187.445 1100.67 186.694C1100.67 185.943 1100.19 185.334 1099.6 185.334C1099.01 185.334 1098.53 185.943 1098.53 186.694C1098.53 187.445 1099.01 188.053 1099.6 188.053Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1471.87 24.8893C1472.46 24.8893 1472.93 24.2806 1472.93 23.5296C1472.93 22.7787 1472.46 22.1699 1471.87 22.1699C1471.28 22.1699 1470.8 22.7787 1470.8 23.5296C1470.8 24.2806 1471.28 24.8893 1471.87 24.8893Z",
    fill: "#D9D9D9"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1248.93 62.9616C1249.52 62.9616 1250 62.3528 1250 61.6019C1250 60.8509 1249.52 60.2422 1248.93 60.2422C1248.34 60.2422 1247.87 60.8509 1247.87 61.6019C1247.87 62.3528 1248.34 62.9616 1248.93 62.9616Z",
    fill: "#D9D9D9"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M991.867 243.801C992.457 243.801 992.934 243.193 992.934 242.442C992.934 241.691 992.457 241.082 991.867 241.082C991.278 241.082 990.801 241.691 990.801 242.442C990.801 243.193 991.278 243.801 991.867 243.801Z",
    fill: "#D9D9D9"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M775.334 141.824C775.923 141.824 776.401 141.215 776.401 140.464C776.401 139.713 775.923 139.104 775.334 139.104C774.745 139.104 774.268 139.713 774.268 140.464C774.268 141.215 774.745 141.824 775.334 141.824Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M846.799 136.385C847.388 136.385 847.866 135.777 847.866 135.026C847.866 134.275 847.388 133.666 846.799 133.666C846.21 133.666 845.732 134.275 845.732 135.026C845.732 135.777 846.21 136.385 846.799 136.385Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_d_2525_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.867 145.903C960.457 145.903 960.934 145.294 960.934 144.543C960.934 143.792 960.457 143.183 959.867 143.183C959.278 143.183 958.801 143.792 958.801 144.543C958.801 145.294 959.278 145.903 959.867 145.903Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2525_567",
    x: 1166.8,
    y: 198.931,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2525_567",
    x: 1224.4,
    y: 130.946,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2525_567",
    x: 258.001,
    y: 135.025,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2525_567",
    x: 1320.4,
    y: 39.8467,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2525_567",
    x: 678.267,
    y: 314.506,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_2525_567",
    x: 115.067,
    y: 61.6011,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_2525_567",
    x: 16.9326,
    y: 110.55,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_2525_567",
    x: 0.932552,
    y: 0.414551,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_2525_567",
    x: 203.601,
    y: 103.752,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_2525_567",
    x: 451.067,
    y: 245.161,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_2525_567",
    x: 407.333,
    y: 155.421,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_2525_567",
    x: 356.134,
    y: 230.204,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_2525_567",
    x: 573.733,
    y: 262.837,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_2525_567",
    x: 1048.4,
    y: 106.472,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_2525_567",
    x: 522.534,
    y: 197.572,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_2525_567",
    x: 493.733,
    y: 23.5298,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_2525_567",
    x: 633.466,
    y: 99.6729,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_2525_567",
    x: 770.001,
    y: 64.3203,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_2525_567",
    x: 955.601,
    y: 41.2056,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_2525_567",
    x: 627.067,
    y: 220.687,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_2525_567",
    x: 763.601,
    y: 220.687,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_2525_567",
    x: 829.733,
    y: 303.628,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_2525_567",
    x: 1094.27,
    y: 185.334,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_2525_567",
    x: 1466.53,
    y: 22.1699,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_2525_567",
    x: 1243.6,
    y: 60.2422,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_2525_567",
    x: 986.534,
    y: 241.082,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_2525_567",
    x: 770.001,
    y: 139.104,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_2525_567",
    x: 841.466,
    y: 133.666,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_2525_567",
    x: 954.534,
    y: 143.183,
    width: 10.6661,
    height: 11.2526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.26667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2525_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2525_567",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessStars);
export default __webpack_public_path__ + "static/media/processStars.8c1ddfb95de6c0a4ec2e63fa17af449b.svg";
export { ForwardRef as ReactComponent };